import { googleMapsLoader } from "../google_maps_loader"

// City types from Google Places API
const CITY_TYPES = ["locality", "administrative_area_level_3"]

let predictionMapper = (prediction) => {
  // Use structured format which has mainText (city name) and secondaryText (state, country)
  // Fallback to full text if structured format not available
  const cityName =
    prediction.structuredFormat?.mainText?.text || prediction.text?.text || ""
  const fullText = prediction.text?.text || ""

  return {
    data: { place_id: prediction.placeId, name: cityName },
    optionText: fullText, // Show full text in dropdown for clarity
    selectionText: cityName, // But only show city name when selected
    imageUrl: null,
  }
}

export const citySelector = {
  mounted() {
    // Ensure input is disabled when mounting
    this.el.querySelector("input")?.setAttribute("disabled", true)

    const extraParams = JSON.parse(this.el.dataset.extraParams || "{}")

    this.el.addEventListener("autocomplete:item-select", (e) => {
      this.pushEventTo(
        this.el,
        this.el.dataset.onSelect,
        Object.assign({}, extraParams, e.detail.data),
      )
    })

    this.el.addEventListener("input", (e) => {
      if (e.target.value == "") {
        this.pushEventTo(this.el, this.el.dataset.onClear, extraParams)
      }
    })

    initAutocomplete()
  },
}

function initAutocomplete() {
  googleMapsLoader
    .importLibrary("places")
    .then(({ AutocompleteSessionToken, AutocompleteSuggestion }) => {
      const autocompleteSessionToken = new AutocompleteSessionToken()

      window.fetchCitiesForAutocomplete ||= async (query) => {
        if (query == "") return []

        try {
          const { suggestions } =
            await AutocompleteSuggestion.fetchAutocompleteSuggestions({
              input: query,
              sessionToken: autocompleteSessionToken,
              includedPrimaryTypes: CITY_TYPES,
            })

          return suggestions
            .map((s) => s.placePrediction)
            .filter((p) => p) // Filter out any undefined predictions
            .map(predictionMapper)
        } catch (error) {
          console.error("[CitySelector] Error fetching suggestions:", error)
          return []
        }
      }

      // Enable inputs marked for autocomplete initialization
      enableCitySelector()
    })
}

const selectorQuery = '[data-city-autocomplete-init="true"]'
function enableCitySelector() {
  document.querySelectorAll(selectorQuery).forEach((input) => {
    input.removeAttribute("disabled")
  })
}
